import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'sms-notification-modal',
    templateUrl: './sms-notification-modal.component.html',
    styleUrls: ['./sms-notification-modal.component.scss']
})
export class SmsNotificationModalComponent implements OnInit {
    @ViewChild('form') form;
    disabledSubmit = false;
    showEditPanel = false;
    message = '';
    placeholders = [
        '[[BUILDING_ADDRESS]]',
        '[[BUILDING_NAME]]',
        '[[UNIT_NUMBER]]',
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[DIRECTION]]',
        '[[RECEIVED_AT]]',
        '[[RECEIVED_BY]]',
        '[[PARCEL_TYPE]]',
        '[[NUMBER_OF_PIECES]]',
        '[[BAR_CODE]]',
        '[[DESCRIPTION]]',
        '[[EMAIL_TO_RESIDENT]]',
        '[[STATUS]]',
        '[[SIGNATURE]]',
        '[[PICKED_UP_AT]]',
        '[[PICKED_UP_BY]]',
        '[[MY_SIGNATURE]]',
        '[[PARCEL_ID]]',
        '[[COURIER]]',
        '[[INVITATION_LINK]]'
    ];
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public settingsParcelsService: SettingsParcelsService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.initSummernote(), 500);
        this.initData();
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsParcelsService.selectedItemData.residentsSmsNotificationSettings) {
            this.settingsParcelsService.selectedItemData.residentsSmsNotificationSettings.forEach((setting) => {
                if(setting.action == (this.settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? this.settingsParcelsService.notificationModalNotificationType : 'picked_up'))
                    this.message = setting.message.replace(/\n/g, '<br>');
            });
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParcelsService.isSmsNotificationModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParcelsService.isSmsNotificationModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        const message = this.message.replace(/<br>/g, '\n').replace(/<[^>]*>/g, '\n').replace(/&nbsp;/g, ' ');
        if(!message) {
            toastr.warning('Email text should not be blank.');
            return;
        }
        const formattedAction = this.settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? this.settingsParcelsService.notificationModalNotificationType : 'picked_up';

        let index = -1;
        let data = {residentsSmsNotificationSettings: []};
        if(this.settingsParcelsService.selectedItemData.residentsSmsNotificationSettings) {
            this.settingsParcelsService.selectedItemData.residentsSmsNotificationSettings.filter((setting) => {
                data.residentsSmsNotificationSettings.push({
                    action: setting.action,
                    message: setting.message
                });
            });
        }
        data.residentsSmsNotificationSettings.forEach((notification, indexInArray) => {
            if(notification.action == formattedAction)
                index = indexInArray;
        });
        if(index != -1) {
            data.residentsSmsNotificationSettings[index] = {
                action: formattedAction,
                message: message
            };
        } else {
            data.residentsSmsNotificationSettings.push({
                action: formattedAction,
            });
            data.residentsSmsNotificationSettings.forEach(notification => {
                if(notification.action == formattedAction)
                    notification.message = message;
            });
        }

        this.disabledSubmit = true;
        const url = `/v1/parcel-service-settings/${this.settingsParcelsService.selectedItemData.corporationNumberBd}.json`;
        this.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('SMS message has been updated successfully'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'SMS message has failed to update');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.updateInfo();
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.message = contents;
                },
                onKeydown: event => {
                    if(event.keyCode != 8 && event.target.textContent.length >= 500)
                        event.preventDefault();
                },
                onPaste: async event => {
                    event.preventDefault();
                    const clipText = await (<any>navigator).clipboard.readText();
                    if (this.message.length + clipText.length < 500)
                        document.execCommand('insertText', false, clipText);
                }
            },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                if(this.message.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<br>/g, '').length < 500) {
                    summernote.summernote('editor.restoreRange');
                    summernote.summernote('editor.focus');
                    summernote.summernote('editor.insertText', e.target.innerText);
                }
            });
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    updateInfo() {
        this.settingsParcelsService.selectedItemData.residentsSmsNotificationSettings.forEach(setting => {
            if(setting.action == (this.settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? this.settingsParcelsService.notificationModalNotificationType : 'picked_up'))
                setting.message = this.message;
        });
    }


    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/sms-notification-modal/sms-notification-modal.component.ts